import React from "react"
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom"
import { createTheme, ThemeProvider } from "@mui/material/styles"
// eslint-disable-next-line import/no-unresolved
import themeOptions from "@thd-eux/theme-mui"
import PrivacyPage from "./components/PrivacyPage"
import PageNotFound from "./components/PageNotFound"
import "./App.css"

const theme = createTheme(themeOptions)

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div className="App">
          <Routes>
            <Route
              path="/"
              element={<Navigate to="/privacy-statement" replace />}
            />
            <Route path="/privacy-statement" element={<PrivacyPage />} />
            <Route path="/*" element={<PageNotFound />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  )
}

export default App
